import { computed, provide } from "vue";
import convertPriceResponse from "../lib/convertPriceResponse";
import { getAmadeusPriceTotal } from "../lib/amadeusPriceDisplayTools";
export default function useCalendarApiPriceProvider(apiPrices, departRef, returnRef, oneWayRef) {
    var convertedPrices = computed(function () {
        if (!apiPrices.value) {
            return { prices: {}, lowestFoundPrice: undefined, highestFoundPrice: undefined, currencies: undefined };
        }
        return convertPriceResponse(apiPrices.value, departRef.value && !oneWayRef.value ? 'returnDate' : 'departureDate');
    });
    var getPriceForDay = computed(function () {
        return function (day) {
            var dateString = day.date.toLocaleDateString('en-CA');
            var price = convertedPrices.value.prices[dateString];
            return price;
        };
    });
    var getFormattedPriceForDay = computed(function () {
        return function (day) {
            var price = getPriceForDay.value(day);
            if (!price) {
                return '';
            }
            var total = getAmadeusPriceTotal(price, convertedPrices.value.currencies);
            return "".concat((total / 1000).toFixed(1), "K");
        };
    });
    provide('getDayExtra', getFormattedPriceForDay);
    function getDayClass(day) {
        var _a, _b;
        var price = getPriceForDay.value(day);
        if (!price) {
            return '';
        }
        if (((_a = convertedPrices.value.lowestFoundPrice) === null || _a === void 0 ? void 0 : _a.total) && (price === null || price === void 0 ? void 0 : price.total) <= ((_b = convertedPrices.value.lowestFoundPrice) === null || _b === void 0 ? void 0 : _b.total)) {
            return 'calendar-day--success';
        }
    }
    provide('getDayClass', getDayClass);
}
